import { apiFetch } from "./client";

export type InternalUser = {
  userId: string;
  displayName: string;
  email: string | null;
};

export type InternalMessage = {
  id: string;
  senderUserId: string;
  body: string;
  createdAt: string;
  mine: boolean;
  readAt: string | null;
  /** Adjunto: una imagen por mensaje. Ruta relativa — pasarla por assetUrl(). */
  imageUrl: string | null;
  /** null = escrito en el buzón; "forjito" = la pregunta libre de la ayuda. */
  origin?: "forjito" | null;
  /** Dónde estaba y con qué rol al preguntar (sólo con origin). */
  originContext?: string | null;
};

export type InternalConversationSummary = {
  id: string;
  otherUser: InternalUser;
  /** `body` vacío + `hasImage` = el último mensaje fue una imagen sola. */
  lastMessage: { body: string; createdAt: string; hasImage: boolean } | null;
  unreadCount: number;
  updatedAt: string;
};

export type InternalConversationDetail = {
  id: string;
  otherUser: InternalUser;
  messages: InternalMessage[];
};

export function fetchInternalConversations() {
  return apiFetch<{ conversations: InternalConversationSummary[] }>(
    "/api/v1/me/internal-conversations",
  );
}

export function fetchInternalConversation(id: string) {
  return apiFetch<InternalConversationDetail>(
    `/api/v1/me/internal-conversations/${id}`,
  );
}

/**
 * El adjunto viaja como ID, no como bytes: la imagen se sube antes por
 * uploadAsset(file, "internal_message") y acá va sólo el id que devolvió.
 * Con imagen, el texto es opcional (y al revés).
 */
export function sendInternalMessage(id: string, body: string, imageAssetId?: string | null) {
  return apiFetch<InternalMessage>(
    `/api/v1/me/internal-conversations/${id}/messages`,
    { method: "POST", body: { body, imageAssetId: imageAssetId ?? undefined } },
  );
}

export function startAdminConversation(
  recipientUserId: string,
  body: string,
  imageAssetId?: string | null,
) {
  return apiFetch<InternalConversationDetail>(
    "/api/v1/admin/internal-conversations",
    { method: "POST", body: { recipientUserId, body, imageAssetId: imageAssetId ?? undefined } },
  );
}

/**
 * `origen` marca la pregunta libre de Forjito (migración 167): entra al mismo
 * hilo que "Enviar comentarios", pero FORJA la ve como "Pregunta a Forjito"
 * con dónde estaba y con qué rol (`contexto`, texto para leer).
 */
export function startSupportConversation(
  body: string,
  imageAssetId?: string | null,
  origen?: { origin: "forjito"; contexto: string } | null,
) {
  return apiFetch<InternalConversationDetail>(
    "/api/v1/me/internal-conversations",
    {
      method: "POST",
      body: {
        body,
        imageAssetId: imageAssetId ?? undefined,
        origin: origen?.origin,
        originContext: origen?.contexto.slice(0, 200) || undefined,
      },
    },
  );
}
